@for (shoppingList of shoppingLists(); track shoppingList; let last = $last) {
  <div class="shopping-list">
    <div class="details">
      <div class="cell full-width">
        <span class="label">Name</span>
        <a (click)="showDetailsClicked(shoppingList.id)">{{ shoppingList.name }}</a>
      </div>
      <div class="cell full-width">
        <span class="label">Eigentümer</span>
        {{ shoppingList.owner }}
      </div>
      <div class="cell">
        <span class="label">Erstelldatum</span>
        {{ shoppingList.createdAt | luxonDate }}
      </div>
      <div class="cell">
        <span class="label">Artikelanzahl</span>
        {{ shoppingList.itemCount }} Positionen
      </div>
    </div>
    <ui-shopping-list-actions
      [shoppingList]="shoppingList"
      class="order-cell no-border full-width has-actions"
    ></ui-shopping-list-actions>
  </div>
}
